import { Timestamp } from "firebase/firestore";

export const formatSessionDate = (date: Timestamp): string => {
  const now = new Date();

  const opts: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    year:
      date.toDate().getFullYear() !== now.getFullYear() ? "numeric" : undefined
  };

  return date.toDate().toLocaleString([], opts);
};
